import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { TransformCta } from "../ui/TransformCta";
export function ProofSection() {
  return <section className="bg-navy px-5 py-16 sm:py-20" data-id="element-246" data-mp="2s4tkehs4t1iy">
      <div className="mx-auto max-w-3xl text-center" data-id="element-247" data-mp="2n69w4aq2fdnf">
        <ShieldCheckIcon className="mx-auto h-12 w-12 text-cyan" aria-hidden="true" data-id="element-248" data-mp="2n4yuagg6kfyy" />
        <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-tight text-white sm:text-5xl" data-id="element-249" data-mp="2i9rsxfadvnd7">
          More Than 1,200 Dental Professionals?
        </h2>
        <div className="mt-6 space-y-4 text-lg leading-relaxed text-white/85" data-id="element-250" data-mp="3axno2fkb177v">
          <p data-id="element-251" data-mp="35wzxtw3wguep">
            I won't publish a customer count, satisfaction percentage, or professional endorsement unless it can be
            verified.
          </p>
          <p data-id="element-252" data-mp="31yacnhcme8ki">
            Instead, the value of the Endo Blueprint™ should be demonstrated through its actual contents: the master map,
            the six volumes, the clinical decision maps, and the practical worksheets.
          </p>
          <p className="font-semibold text-white" data-id="element-253" data-mp="2dj6opigbffnn">
            The best way to understand the product is to see how its visual framework is organized.
          </p>
        </div>
        <TransformCta tone="dark" label="Show Me the Complete Framework" data-id="element-254" data-mp="24j0eq6jtsxt8" />
      </div>
    </section>;
}